<template>
  <div class="home">
    <!-- 顶栏 sticky 定位：向下=仅Filter，向上=PageHeader+Filter -->
    <div ref="topBar"
         class="goods-top"
         :class="topBarClass">
      <div class="goods-top__hd">
        <PageHeader />
      </div>

      <FilterGoods :expert-id="expert.id"
                   :default-parent-cate-ids="parentCateIds"
                   :default-cate-ids="cateIds"
                   :keyword="searchKeyword"
                   @goGoodsSearch="goGoodsSearch"
                   @filterApply="handleFilterApply" />
    </div>

    <!-- 热销商品 -->
    <div class="best-sellers-section">
      <div class="container">
        <div>
          <!-- 商品列表 -->
          <ProductList ref="productList"
                       :expert-id="expert.id"
                       :sortBy="sortBy"
                       :parentCateIds="parentCateIds"
                       :cateIds="cateIds"
                       :searchKeyword="searchKeyword"
                       :brands="brandName"
                       :tags="tags"
                       @goods-selected="handleBuyNow"
                       :currencySymbol="expert.currencySymbol"
                       :currencyId="expert.currencyId"
                       :templateType="2" />
        </div>
      </div>
    </div>

    <RightFixedPanel />

    <PageFooter />
  </div>
</template>

<script>
import { getExpertConfig, getGoodsCategoryList } from '@/api/cache'
import RightFixedPanel from '@/components/RightFixedPanel.vue'
import ProductList from '@/components/ProductList.vue'
import CategoryList from '@/components/CategoryList.vue'
import BrandList from '@/components/BrandList.vue'
import SelectPurchasingPlatform from '@/components/selectPurchasingPlatform.vue'
import PageHeader from './components/pageHeader.vue'
import PageFooter from './components/pageFooter.vue'
import FilterGoods from './components/filter-goods.vue'
import { openPlatformBuy, reportGoodsClick } from '@/utils/goodsAction'

export default {
  name: 'Home',
  components: {
    RightFixedPanel,
    ProductList,
    CategoryList,
    BrandList,
    SelectPurchasingPlatform,
    PageHeader,
    PageFooter,
    FilterGoods
  },
  data() {
    return {
      showPlatform: 'N',
      noSelectPlatformBg: '#373737',
      selectPlatformBg: '#486AFF',
      searchKeyword: '',
      sortBy: '', //排序方式
      parentCateIds: '', //一级分类 ID
      cateIds: '', //二级分类 ID
      brandName: '', //选中的品牌名称
      tags: '', //选中的商品品质
      expert: {}, //达人信息
      storeDecoration: {}, //店铺装修信息
      storeTheme: {}, //店铺主题信息
      bgImageUrl: '', //默认背景图
      mobileBgImageUrl: '', //移动端默认背景图
      logoImageUrl: '', //PC 端默认 Logo 图
      mobileLogoImageUrl: '', //移动端默认 Logo 图
      linkImageUrls: [],
      selectPlatform: {},
      platformId: '',
      initLoading: true,
      isMobile: window.innerWidth < 768,
      currency: {},
      // 顶栏滚动：up=PageHeader+Filter，down=仅 Filter
      scrollState: {
        mode: 'full',
        lastY: 0
      },
      oldScrollTop: 0,    // 记录上次滚动位置
      scrollDelay: 10,     // 滚动节流延迟时间(ms)
      scrollThreshold: 20, // 最小滚动变化阈值，防止微小抖动（增加到 20px）
      lastScrollTime: 0,   // 记录上次切换状态的时间
      switchDelay: 400,    // 状态切换的最小间隔时间(ms)，防止频繁翻转（增加到 400ms）
      hideThreshold: 50    // 向下滚动隐藏菜单的最小距离阈值
    }
  },
  computed: {
    topBarClass() {
      const s = this.scrollState
      return {
        'goods-top--scrolled': s.mode === 'filter',
        'goods-top--filter': s.mode === 'filter'
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollThrottle())
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollThrottle())
  },
  watch: {
    // 监听 /goods?categoryName=xx 路由变化，同步默认分类
    '$route.query': {
      deep: true,
      handler() {
        this.syncRouteQuery()
      }
    }
  },
  async created() {
    this.syncRouteQuery()
    // 加载达人、装修主题
    await this.loadExpertConfig()
    await this.$nextTick(() => {
      var styleConfig = this.$styleManager.getCurrentConfig()
      if (styleConfig) {
        this.noSelectPlatformBg = styleConfig.backgroundColor === '#26292C' ? '#373737' :
          '#E8E8E9'
      }
      if (styleConfig) {
        this.selectPlatformBg = styleConfig.primaryColor || styleConfig.themeColor || '#486AFF'
      }

      // 处理平台选择
      if (this.expert?.expertPlatformList?.length > 0) {
        const sele = JSON.parse(sessionStorage.getItem('selectPlatform'))

        if (sele) {
          this.selectPlatform = sele
        } else {
          // 查找默认平台
          const defaultPlatform = this.expert.expertPlatformList.find(item => item.defaulted ===
            'Y')
          // 如果没有默认平台，使用第一个平台
          this.selectPlatform = defaultPlatform || this.expert.expertPlatformList[0]
        }
      }

      if (this.expert.id) {
        //加载商品分类
        if (this.$refs.categoryList && typeof this.$refs.categoryList.init === 'function') {
          this.$refs.categoryList.init()
        }
        //加载商品品牌
        if (this.$refs.brandList && typeof this.$refs.brandList.init === 'function') {
          this.$refs.brandList.init()
        }
        //加载商品列表：当路由参数包含 cateparentCateNames 或 cateNames 时，由 findCategoryIdsByName 统一触发，避免重复请求
        const cateParentCateNamesQ = this.$route.query.cateparentCateNames
        const cateNamesQ = this.$route.query.cateNames
        if (!cateParentCateNamesQ && !cateNamesQ) {
          if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
            this.$refs.productList.init()
          }
        }
      }
    })
  },
  methods: {
    handleScrollThrottle() {
      let timer = null
      return () => {
        if (!timer) {
          timer = setTimeout(() => {
            this.handleScroll()
            timer = null
          }, this.scrollDelay)
        }
      }
    },
    handleScroll() {
      const newScrollTop = window.pageYOffset || document.documentElement.scrollTop
      const now = Date.now()

      // 1. 如果在页面顶部附近，强制显示完整导航
      if (newScrollTop <= 10) {
        if (this.scrollState.mode !== 'full') {
          this.scrollState.mode = 'full'
          this.lastScrollTime = now
        }
        this.oldScrollTop = newScrollTop
        return
      }

      const diff = newScrollTop - this.oldScrollTop

      // 2. 过滤微小抖动：如果滚动距离小于阈值，不处理且不更新基准点
      if (Math.abs(diff) < this.scrollThreshold) {
        return
      }

      // 3. 频率限制：如果距离上次切换状态时间太短，忽略本次切换
      // 关键：在冷却期内不更新 oldScrollTop，避免基准点漂移
      if (now - this.lastScrollTime < this.switchDelay) {
        // 超过阈值但在冷却期内，仍更新基准点防止累积误差
        this.oldScrollTop = newScrollTop
        return
      }

      // 4. 根据滚动方向切换状态
      let nextMode = this.scrollState.mode
      if (diff > 0 && newScrollTop >= this.hideThreshold) {
        // 向下滚动且超过隐藏阈值 -> 隐藏 PageHeader (filter 模式)
        nextMode = 'filter'
      } else if (diff < 0) {
        // 向上滚动 -> 显示 PageHeader (full 模式)
        nextMode = 'full'
      }

      // 5. 只有当状态真正改变时才赋值，避免不必要的渲染和闪烁
      if (nextMode !== this.scrollState.mode) {
        this.scrollState.mode = nextMode
        this.lastScrollTime = now
      }

      // 6. 仅当 diff >= threshold 时更新 oldScrollTop，避免回流导致的基准点漂移
      this.oldScrollTop = newScrollTop
    },

    // 从路由 query 同步搜索词、分类 ID
    syncRouteQuery() {
      const q = this.$route.query.keyword
      const kw = Array.isArray(q) ? q[0] : q
      this.searchKeyword = typeof kw === 'string' ? kw.trim() : ''

      // 优先处理分类名称参数（来自 home-featured-categories 的跳转）
      const cateParentCateNamesQ = this.$route.query.cateparentCateNames
      const cateNamesQ = this.$route.query.cateNames

      if (cateParentCateNamesQ || cateNamesQ) {
        // 如果有分类名称参数，需要遍历分类树找到对应的 ID
        this.findCategoryIdsByName(cateParentCateNamesQ, cateNamesQ)
        return
      }

      // 一级分类 ID
      const parentCateIdQ = this.$route.query.parentCateIds || this.$route.query.parentCateId
      const parentRaw = Array.isArray(parentCateIdQ) ? parentCateIdQ[0] : parentCateIdQ
      this.parentCateIds = typeof parentRaw === 'string' ? parentRaw.trim() : ''

      // 二级分类 ID
      const cateIdQ = this.$route.query.cateIds || this.$route.query.cateId
      const cateRaw = Array.isArray(cateIdQ) ? cateIdQ[0] : cateIdQ
      this.cateIds = typeof cateRaw === 'string' ? cateRaw.trim() : ''

      if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
        this.searchByKeyword()
      }
    },

    /**
     * 根据分类名称查找对应的分类 ID
     * @param {string} parentCateNames - 父级分类名称（可选）
     * @param {string} cateNames - 子级分类名称（可选）
     */
    async findCategoryIdsByName(parentCateNames, cateNames) {
      try {
        // 等待 this.expert.id 有值
        if (!this.expert || !this.expert.id) {
          console.warn('expert.id 未加载，等待中...')
          // 最多等待 5 秒，每次间隔 100ms
          let waitCount = 0
          const maxWait = 50 // 50 * 100ms = 5s

          while ((!this.expert || !this.expert.id) && waitCount < maxWait) {
            await new Promise(resolve => setTimeout(resolve, 100))
            waitCount++
          }

          if (!this.expert || !this.expert.id) {
            console.error('等待 expert.id 超时，无法获取分类列表')
            return
          }
        }

        // 请求获取分类列表
        const res = await getGoodsCategoryList(this.expert.id)
        const list = res.data || []

        const parentObj = list.filter(item => item.categoryName === parentCateNames)
        if (!parentObj || !parentObj.length) {
          console.warn('未找到匹配的父级分类:', parentCateNames)
          return
        }
        this.parentCateIds = String(parentObj[0].id)

        const subCategoryList = parentObj[0]?.subCategoryList || []
        const cateObj = subCategoryList.filter(item => item.categoryName === cateNames)
        if (!cateObj || !cateObj.length) {
          console.warn('未找到匹配的子级分类:', cateNames)
          return
        }
        this.cateIds = String(cateObj[0].id)

        if (this.$refs.productList && typeof this.$refs.productList.init === 'function') {
          this.searchByKeyword()
        }
      } catch (error) {
        console.error('查找分类 ID 失败:', error)
      }
    },

    // 加载达人、装修主题
    async loadExpertConfig() {
      try {
        const response = await getExpertConfig()
        const {
          data
        } = response
        this.showPlatform = data.storeShowPlatform
        // 加载达人信息
        this.expert = data.expert

        //设置默认LOGO
        this.logoImageUrl = data.pcLogoUrl
        //设置移动端默认LOGO
        this.mobileLogoImageUrl = data.mobileLogoUrl
        // 设置默认背景图
        this.bgImageUrl = data.pcBgUrl
        // 设置移动端默认背景图
        this.mobileBgImageUrl = data.mobileBgUrl

        document.getElementById('dynamic-favicon').href = data.domainImage
        document.title = data.domainTitle

        this.initLoading = false

        // 处理店铺装修
        if (data.storeDecoration) {
          this.storeDecoration = data.storeDecoration
          // 设置社群Link图
          if (this.storeDecoration.linkImageUrl) {
            try {
              this.linkImageUrls = JSON.parse(this.storeDecoration.linkImageUrl)
            } catch (parseError) {
              this.linkImageUrls = []
            }
          }
        }
      } catch (error) {
        // 加载达人配置失败，请联系运营
        console.warn('Failed to load the expert configuration. Please contact the operator', error)
      }
    },

    //切换代购平台
    handleChangeExpert(platform) {
      this.selectPlatform = platform
    },

    goGoodsSearch(keyword) {
      this.searchKeyword = keyword
      this.searchByKeyword()
    },

    /**
     * 处理筛选条件应用
     * @param filter 筛选条件对象
     */
    handleFilterApply(filter) {
      console.log('筛选条件参数', filter)
      this.sortBy = filter.sortBy
      // Filter 选二级/多选：parentCateIds 和 cateIds
      this.parentCateIds = filter.parentCateIds.join(',')
      this.cateIds = filter.cateIds.join(',')
      this.brandName = filter.brands.join(',')
      this.tags = filter.qualities.join(',')
      this.searchByKeyword()
    },

    searchByKeyword() {
      setTimeout(() => {
        this.$refs.productList.init()
      }, 100)
    },

    // 处理品牌选择
    handleBrandSelected(brand) {
      this.brandName = brand.brandName
      this.searchByKeyword()
    },
    //社群link图跳转
    handleLink(link) {
      if (link.isLink == 'Y') {
        window.open(link.linkAddress)
      }
    },
    //立即购买
    handleBuyNow(goods) {
      reportGoodsClick(goods)
      openPlatformBuy(this.selectPlatform, goods)
    }
  }
}
</script>

<style scoped>
:deep .el-dialog--center .el-dialog__body {
  padding: 0 20px;
}

.home {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--background-color);
}

.best-sellers-section {
  flex: auto;
}

/* 顶栏 sticky 定位，始终固定在顶部 */
.goods-top {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  background-color: var(--background-color);
}

.goods-top--scrolled {
  box-shadow: 0 4px 12px hsl(from var(--background-color) h s l / 0.35);
}

.goods-top--filter .goods-top__hd {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}

.goods-top__hd {
  max-height: 200px;
  opacity: 1;
  pointer-events: auto;
  transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
  will-change: max-height, opacity;
}

.container {
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.hero {
  max-width: none;
  padding: 0 !important;
  position: relative;
  width: 100%;
}

.bg-image {
  width: 100%;
  height: 300px;
}

.platform {
  color: var(--link-color);
  margin: 0 8px;
}

/* 顶部Logo、社群Link样式 */
.logo-link {
  position: absolute;
  bottom: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  padding: 0;
  height: 300px;
  padding-right: 40px;
}

.logo-img {
  width: 100%;
  max-width: 400px;
  height: auto;
  max-height: 170px;
  border-radius: 10px;
}

.link-img {
  width: 100%;
  max-width: 250px;
  height: auto;
  max-height: 35px;
  border-radius: 10px;
  margin-top: 5px;
  cursor: pointer;
}

.search-layout {
  display: flex;
  flex-direction: column;
}

.search-sub-layout {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
}

.search-container {
  display: flex;
  justify-content: center;
  z-index: 10;
  flex-direction: column;
}

.search-wrapper {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
}

.custom-search-input {
  display: flex;
  align-items: center;
  border-radius: 4px;
  width: 80%;
  overflow: hidden;
}

.search-button {
  color: white;
  border: none;
  height: 42px;
  width: 160px;
  cursor: pointer;
  font-size: 17px;
  transition: background-color 0.3s;
}

.platform-left {
  margin-left: 10px;
}

/* 悬浮弹窗样式 */
.popup-layout {
  max-height: 300px;
  overflow-y: auto;
  /* 滚动条美化 */
  scrollbar-width: thin;
}

.popup-content {
  gap: 10px;
  padding: 15px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.platform-filter {
  padding: 10px 20px;
  border-radius: 10px;
  color: var(--link-color);
  cursor: pointer;
  font-size: 17px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  white-space: nowrap;
  position: relative;
  z-index: 9998 !important;
  /* 确保分类过滤器不会裁剪下拉菜单 */
  overflow: visible !important;
  display: flex;
  align-items: center;
}

.platform-filter-img {
  width: 30px;
  height: 30px;
  border-radius: 8px;
}

.platform-filter.active {
  font-weight: bold;
  color: #fff;
  background: var(--primary-color);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .logo-link {
    padding: 0;
    width: 95%;
  }

  .search-layout {
    padding: 0 10px 0 0;
  }
}

@media (max-width: 768px) {
  .bg-image {
    height: 250px;
  }

  .logo-link {
    align-items: center;
    gap: 0;
    left: 0;
    padding: 0 10px;
    bottom: 30px;
    width: 100%;
  }

  .search-sub-layout {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .custom-search-input {
    width: 100%;
  }

  .search-button {
    width: 100px;
  }

  .logo-img {
    width: 80px;
    height: 80px;
    border-radius: 100px;
    border: 3px solid var(--primary-color);
  }

  .link-img {
    width: 250px;
    height: 28px;
  }

  .search-wrapper {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 10px;
  }

  .platform-filter {
    font-size: 15px;
    padding: 5px 10px;
  }

  .platform-filter-img {
    width: 22px;
    height: 22px;
  }

  .logo-img {
    max-width: 200px;
    max-height: 100px;
  }

  .link-img {
    width: 250px;
    height: 28px;
    margin-top: 0;
  }

  .search-layout {
    padding: 0;
  }

  .search-wrapper {
    padding: 10px;
  }

  .search-button {
    font-size: 15px;
    height: 42px;
  }

  .platform-left {
    margin-left: 0;
  }

  :deep .el-select {
    width: 100%;
  }

  :deep .el-input__inner {
    height: 40px;
    font-size: 15px;
  }

  :deep .el-input__icon {
    line-height: 40px;
  }

  :deep .el-input--prefix input {
    font-size: 16px;
  }
}

:deep .search-input,
:deep.search-input input {
  border-radius: 0 !important;
  border: 1px solid var(--border-color) !important;
  border-right: none !important;
}

:deep .el-input__prefix {
  display: flex;
  align-items: center;
}

:deep .el-input--prefix input {
  padding-left: 35px !important;
}
</style>